// extracted by mini-css-extract-plugin
export default {"productGallery":"xM-z","inQuickShop":"yM-z"};